import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import storage from 'libs/storage'
import store from '@/store'
import api from '@/api'
import wechat from 'libs/wechat'
import {Dialog, Toast} from 'vant'
import utils from 'libs/utils'

Vue.use(Router)
const router = new Router({
    routes,
    mode: 'history'
})
const LOGIN_PAGE_NAME = 'login';
const homeName = 'index';
var checkLogin = (to, token, next, from) => {

    if (to.meta.requiresAuth === true) {

        if (!token && to.name !== LOGIN_PAGE_NAME) {
            store.dispatch("getUserInfo")
                .then(user => {
                    checkLogin(to, user.token, next, from);
                })
                .catch(() => {
                    // 未登录且要跳转的页面不是登录页 记录跳转地址后 登录成功后回调
                    Dialog.confirm({
                        title: '提示',
                        message: '当前页面需要登录后才可访问,前往登录页面?',
                    }).then(() => {
                        utils.setLastRouter(to)
                        next({
                            name: LOGIN_PAGE_NAME // 跳转到登录页
                        })
                    }).catch(() => {

                        if (from.name === null) {
                            next({
                                name: homeName // 跳转到homeName页
                            })
                        }

                    });

                });


        } else {
            next();
        }

    } else {

        if (token && to.name === LOGIN_PAGE_NAME) {
            // 已登录且要跳转的页面是登录页
            next({
                name: homeName // 跳转到homeName页
            })
        } else {
            next();
        }



    }
}
var share = function () {
    return wechat.updateShareData({
        title: '浦东新区游泳救生服务平台',
        description: '浦东新区游泳救生服务平台，集报名、招聘、求职于一体，为救生员提供全面的服务！',
        imageUrl: 'https://img1.outnice.cn/images/2020/08/17/image_1597674405_vt3m9T9P.png',
        link:`${window.location.protocol}//${ window.location.host}${window.entryUrl}`
    })
}
router.beforeEach((to, from, next) => {
    if (to.meta.showloading) {
        Toast.loading({
            duration: 0, // 持续展示 toast
            overlay: false,
            forbidClick: true
        });
    }
    //appInfo 原始链接
    let token = utils.getToken()

    if (to.meta.bgcolor) {
        store.commit('setBgColor', to.meta.bgcolor)
    } else {
        store.commit('setBgColor', '#ffffff')
    }
    //版本管理
    // api.system.getVersion().then((res) => {
    //     let newver = res.ver;
    //     storage.get('version').then((res) => {
    //         //版本发生变化
    //         if(res !== newver){
    //             storage.set('version',newver);
    //             window.location.reload();
    //         }
    //     });
    // })
    checkLogin(to, token, next, from);
})
router.afterEach((to) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }

    if (window.__wxjs_is_wkwebview) {
        // IOS
        if (window.entryUrl === "" || window.entryUrl === undefined) {
            window.entryUrl =  `${to.fullPath}`;
        }
    } else {
        // 安卓
        window.entryUrl = `${to.fullPath}`;
    }
    if (to.meta.share)
    {
        if(process.env.NODE_ENV != 'development')
            share();
    }

    if (to.meta.showloading) {
        setTimeout(() => {
            Toast.clear()
        }, 10e2)
    }
})

export default router
